<template>
  <el-dialog
    title="Lý do hủy đặt phòng"
    :visible.sync="dialogCancelVisible"
    :close-on-click-modal="false"
    width="500px"
    append-to-body
  >
    <p>Số dư : {{ balance }}</p>
    <hr />
    <div class="das-form-container">
      <div class="das-form-group">
        <div class="das-form-row">
          <div class="das-form-col col-12">
            <div class="das-form-input">
              <div class="label required">Chọn lý do hủy đặt phòng</div>
              <div class="child-w-80">
                <!-- <textarea v-model="cancelReason" rows="5" /> -->
                <el-select v-model="cancelReason" placeholder="Vui lòng chọn">
                  <el-option
                    v-for="item in cancelReasonOptions"
                    :key="item.id"
                    :label="item.reason"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <div class="button-containers">
        <button
          class="btn primary small outline"
          @click="dialogCancelVisible = false"
        >
          {{ 'Đóng' }}
        </button>
        <button class="btn primary small" @click="onCfCancelBooking">
          {{ 'Xác nhận' }}
        </button>
        <button
          class="btn primary small"
          @click="$router.push({ path: '/reservation/new_reservation' })"
        >
          {{ 'Tạo đặt phòng khác' }}
        </button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import { cancelBooking } from '@/api/reception/reception'
import { getReasonCancelApi } from '@/api/Service_Policy/reasonCancel.js'
import { notifySuccess } from '@/utils/toast'
import { getRoomBalanceCancelApi } from '@/api/booking_service/bookingGroup'
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array
    }
  },
  data() {
    return {
      balance: 0,
      cancelReason: null,
      cancelReasonOptions: []
    }
  },
  computed: {
    dialogCancelVisible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    listID() {
      return this.data.map(item => item.sub_booking_group_id)
    }
  },
  watch: {
    dialogCancelVisible() {
      this.getBalanceBooking()
    }
  },

  mounted() {
    // console.log(this.data, 'chcek cancel')
    this.getCancelReason()
  },

  methods: {
    // handle event
    onCfCancelBooking() {
      this.fnCancelBooking(this.listID)
    },
    async getBalanceBooking() {
      console.log(this.listID)
      const res = await getRoomBalanceCancelApi({ ids: this.listID })
      // console.log(res.data)
      this.balance = res.data
    },

    // handle api call
    getCancelReason() {
      getReasonCancelApi({ status: true })
        .then(res => {
          console.log(res.data.map(item => item.code))
          this.cancelReasonOptions = res.data
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t(
              'errorMsg.' + error?.response?.data?.message
                ? error?.response?.data?.message
                : error
            )
          })
        })
        .finally(() => {})
    },
    fnCancelBooking(idList) {
      cancelBooking({ ids: idList, cancel_reason: this.cancelReason })
        .then(data => {
          if (!data.is_error) {
            notifySuccess(data.message)
            this.cancelReason = null
            this.dialogCancelVisible = false
            this.$emit('submit')
          } else {
            this.$message({
              message: this.$t('errorMsg.' + data.message),
              type: 'error'
            })
          }
        })
        .catch(error => {
          this.$message({
            message: this.$t(
              'errorMsg.' + error.response?.data?.message || error
            ),
            type: 'error'
          })
        })
        .finally(() => {})
    }
  }
}
</script>
